/* ZO•ON – prices in EUR or USD on the English site (19.10.2026)
   Loaded only on the English version (snippets/zoon-features.liquid).
   - Visitors in the Americas see USD, everyone else sees EUR (from the browser's time zone).
     ?currency=usd / ?currency=eur in the URL picks one and it is remembered in this browser.
   - Rates: European Central Bank daily rates (frankfurter.dev), kept for 12 hours in this browser.
     If that service can't be reached, fixed fallback rates below are used.
   - Display only: Shopify can't charge in EUR/USD for an Icelandic store (no Shopify Payments in Iceland),
     so checkout stays in ISK. A short note says so in the cart and under the add-to-bag button. */
(function () {
  if (!window.ZOON || !window.ZOON.en) return;

  var FALLBACK = { EUR: 0.0073, USD: 0.0082 }; // ISK -> EUR / USD, used only when live rates are unavailable
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function pickCurrency() {
    var m = location.search.match(/[?&]currency=(usd|eur)/i);
    if (m) { store.set('zoon_cur', m[1].toUpperCase()); return m[1].toUpperCase(); }
    var saved = store.get('zoon_cur');
    if (saved === 'USD' || saved === 'EUR') return saved;
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    return /^America\//.test(tz) ? 'USD' : 'EUR';
  }

  var CUR = pickCurrency();
  var rate = FALLBACK[CUR];
  var fmt = new Intl.NumberFormat('en', { style: 'currency', currency: CUR, maximumFractionDigits: 0, minimumFractionDigits: 0 });

  // "14,990 ISK", "14.990 kr.", "ISK 14,990", "14990 kr"
  var RE = /(?:ISK\s?(\d{1,3}(?:[.,]\d{3})+|\d+)(?:[.,]\d{2})?)|(?:(\d{1,3}(?:[.,]\d{3})+|\d+)(?:[.,]\d{2})?\s?(?:ISK|kr\b\.?))/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, OPTION: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  function convertText(s) {
    return s.replace(RE, function (all, a, b) {
      var isk = parseInt((a || b).replace(/[.,]/g, ''), 10);
      if (!isFinite(isk)) return all;
      return fmt.format(Math.round(isk * rate));
    });
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixNode(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName] || (root.closest && root.closest('[data-zcur-skip]'))) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || (p.closest && p.closest('[data-zcur-skip]'))) return NodeFilter.FILTER_REJECT;
        return /ISK|kr/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var list = [], n;
    while ((n = tw.nextNode())) list.push(n);
    list.forEach(fixNode);
  }

  function fixNode(n) {
    var v = n.nodeValue;
    if (!v || !/ISK|kr/.test(v)) return;
    var out = convertText(v);
    if (out !== v) n.nodeValue = out;
  }

  var NOTE = 'Prices are shown in ' + CUR + ' as an estimate. You pay in Icelandic krónur (ISK) at checkout, so the final amount depends on your card’s exchange rate.';
  function addNotes() {
    var targets = document.querySelectorAll('.side-cart .checkout-btn, .cart__checkout, form[action$="/cart"] [name="checkout"], .product-form__add-to-cart');
    targets.forEach(function (btn) {
      var host = btn.closest('.btn') && !btn.classList.contains('btn') ? btn.closest('.btn') : btn;
      if (host.nextElementSibling && host.nextElementSibling.classList.contains('zoon-cur-note')) return;
      var p = document.createElement('p');
      p.className = 'zoon-cur-note';
      p.setAttribute('data-zcur-skip', '');
      p.textContent = NOTE;
      host.insertAdjacentElement('afterend', p);
    });
  }

  function run() {
    walk(document.body);
    addNotes();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = '.zoon-cur-note{margin:10px 0 0;font-size:11px;line-height:1.5;color:#666;letter-spacing:.02em;text-align:left}';
    document.head.appendChild(css);
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function loadRate(done) {
    var key = 'zoon_rate_' + CUR, cached = null;
    try { cached = JSON.parse(store.get(key) || 'null'); } catch (e) {}
    if (cached && cached.r && Date.now() - cached.t < 12 * 3600 * 1000) { rate = cached.r; return done(); }
    var finished = false;
    var timer = setTimeout(function () { if (!finished) { finished = true; done(); } }, 2500);
    fetch('https://api.frankfurter.dev/v1/latest?base=ISK&symbols=' + CUR)
      .then(function (r) { return r.json(); })
      .catch(function () { return fetch('https://open.er-api.com/v6/latest/ISK').then(function (r) { return r.json(); }); })
      .then(function (j) {
        var r = j && j.rates && j.rates[CUR];
        if (r) { rate = r; store.set(key, JSON.stringify({ r: r, t: Date.now() })); }
      })
      .catch(function () {})
      .then(function () { if (!finished) { finished = true; clearTimeout(timer); done(); } });
  }

  loadRate(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  });
})();